module.exports = " <div> loading…… </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
 ** module id = 653
 ** module chunks = 2
 **/